var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"cm-mg-p-wzd"},[_vm._v("2.1 "+_vm._s(_vm.$t('pqr.client_location_info')))]),_c('hr'),_c('select-address',{on:{"showHideLoading":_vm.showHideLoading,"onChange":_vm.handleChangeSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }